module.exports = __webpack_public_path__ + "img/chart2-md.ee71b917.webp";